<div class="container-fluid m-0 p-0" appFitViewport [ngClass]="{ 'dark-theme': isDark, 'light-theme': !isDark }" style="overflow: hidden;">
    <!-- Agrega esto al principio del template, justo después de la etiqueta de apertura del componente principal -->
    <mat-card *ngIf="!apiIbkrAvailable && BrokoptimalWallet?.tipoBroker !== 'METAAPI'" class="alert-card">
        <mat-card-content>
            <p>
                <mat-icon>warning</mat-icon>
                La API de IBKR no está disponible en este momento. Algunas funcionalidades pueden estar limitadas.
            </p>
        </mat-card-content>
    </mat-card>

    <mat-card *ngIf="isLoadingMetaapi" class="metaapi-download-toast">
        <mat-card-content class="d-flex align-items-center gap-2 py-1">
            <small class="metaapi-toast-label">
                Descargando {{ candlesDownloadSymbol || 'datos' }} MetaAPI{{ candlesDownloadFase ? ' — ' + faseLabel(candlesDownloadFase) : '' }}...
                <span *ngIf="candlesDownloadExpected > 0">
                    {{candlesDownloadTotal | number:'1.0-0'}}/{{candlesDownloadExpected | number:'1.0-0'}}
                    ({{(candlesDownloadTotal / candlesDownloadExpected) * 100 | number:'1.0-0'}}%)
                </span>
            </small>
            <mat-progress-bar
              [mode]="candlesDownloadExpected > 0 ? 'determinate' : 'indeterminate'"
              [value]="candlesDownloadExpected > 0 ? (candlesDownloadTotal / candlesDownloadExpected) * 100 : 0"
              style="border-radius:4px;">
            </mat-progress-bar>
        </mat-card-content>
    </mat-card>

    <!-- El resto de tu template HTML -->

    <!-- Panel flotante de control -->
    <div class="floating-control-panel" (mouseover)="expandirDiv()" (mouseout)="contraerDiv()" 
         [ngClass]="{'expanded': mouseSobreDiv}">
        <div class="panel-toggle">
            <mat-icon>{{mouseSobreDiv ? 'chevron_left' : 'menu'}}</mat-icon>
        </div>
        <div class="panel-content">
            <h6 class="panel-title mb-2">Paneles</h6>
            <div class="panel-option">
                <mat-checkbox [checked]="cartera" (change)="showTab('cartera')" [color]="'primary'">
                    Cartera
                </mat-checkbox>
            </div>
            <div class="panel-option">
                <mat-checkbox [checked]="listaMercado" (change)="showTab('lista')" [color]="'primary'">
                    Lista Mercados
                </mat-checkbox>
            </div>
        </div>
    </div>

    <div class="row-container p-0 m-0" #rowContainer style="height: 100%;">
        <div class="mb-4 col-md-2 p-0 m-0 resizable-column h-100" #column1 *ngIf="cartera" data-key="broker_col_cartera">
            <div class="resizer" (mousedown)="startResizing($event, column1)" title="Arrastrar para redimensionar"></div>
            <mat-card class="enrolled-created-box ccorbit-card no-scrollbar h-100">
                <mat-card-content class="h-100 d-flex flex-column">
                    <div class="ccorbit-form-group without-icon">
                        <div class="oc-section-header">
                            <span>CARTERA ÓPTIMA</span>
                            <mat-icon class="oc-help-icon" (click)="showCarteraHelp()" matTooltip="Ayuda">help_outline</mat-icon>
                        </div>

                        <div class="oc-grid">
                            <label class="oc-label">Capital Inicial</label>
                            <input class="oc-input" type="number" [(ngModel)]="BrokoptimalWallet.capitalinicial" [disabled]="true">

                            <label class="oc-label">Valor Liq. Neto</label>
                            <input class="oc-input" type="number" [(ngModel)]="BrokoptimalWallet.valorLiquidativo" [disabled]="true">

                            <label class="oc-label">Valor Liq. Broker</label>
                            <input class="oc-input" type="number" [(ngModel)]="walletBroker.ValorLiquidativo" [disabled]="true">

                            <label class="oc-label">Efectivo</label>
                            <input class="oc-input" type="number" [(ngModel)]="BrokoptimalWallet.efectivo" [disabled]="true"
                                [ngClass]="{'input-error-letra': !efectivopositivo}">

                            <label class="oc-label">Efectivo Broker</label>
                            <input class="oc-input" type="number" [(ngModel)]="walletBroker.Efectivo" [disabled]="true"
                                [ngClass]="{'input-error-letra': !efectivopositivobroker}">

                            <label class="oc-label">Tipo Cuenta</label>
                            <select class="oc-select" aria-label=".form-select-sm example" (change)="disabledMargin($event)"
                                [(ngModel)]="BrokoptimalWallet.tipocuenta" [disabled]="true">
                                <option selected>Seleccionar</option>
                                <option value="{{type}}" *ngFor=" let type of accountType">{{type}}</option>
                            </select>

                            <label class="oc-label">Margen Requerido %</label>
                            <input class="oc-input" type="number" [(ngModel)]="BrokoptimalWallet.margenRequeridoPor" [disabled]="true">

                            <label class="oc-label">Margin Call %</label>
                            <input class="oc-input" type="number" [(ngModel)]="BrokoptimalWallet.controlMarginCall" [disabled]="true">

                            <label class="oc-label">Margen Total</label>
                            <input class="oc-input" type="number" [(ngModel)]="BrokoptimalWallet.margen" [disabled]="true"
                                [ngClass]="{'input-error': !existemargen, 'input-normal': existemargen}">

                            <label class="oc-label">Margen Total Broker</label>
                            <input class="oc-input" type="number" [(ngModel)]="walletBroker.MargenTotal" [disabled]="true"
                                [ngClass]="{'input-error': !existemargenbroker, 'input-normal': existemargenbroker}">

                            <label class="oc-label">Fondos Disponibles</label>
                            <input class="oc-input" type="number" [(ngModel)]="BrokoptimalWallet.fondosDisponibles" [disabled]="true">

                            <label class="oc-label">Disponibles Broker</label>
                            <input class="oc-input" type="number" [(ngModel)]="walletBroker.FondosDisponible" [disabled]="true">

                            <label class="oc-label">Poder Aquisitivo</label>
                            <input class="oc-input" type="number" [(ngModel)]="BrokoptimalWallet.poderCompra" [disabled]="true">

                            <label class="oc-label">Buying Power Broker</label>
                            <input class="oc-input" type="number" [(ngModel)]="walletBroker.PoderAdquisitivo" [disabled]="true">

                            <label class="oc-label">Apalancamiento</label>
                            <input class="oc-input" type="number" [(ngModel)]="BrokoptimalWallet.apalancamiento" [disabled]="true">
                        </div>

                        <div class="oc-section-header">
                            <span>CONFIGURACIÓN RIESGO</span>
                            <mat-icon class="oc-help-icon" (click)="showRiesgoHelp()" matTooltip="Ayuda">help_outline</mat-icon>
                        </div>

                        <div class="oc-grid">
                            <label class="oc-label">Riesgo Maximo</label>
                            <input class="oc-input" type="number" [(ngModel)]="BrokoptimalWallet.riesgomaximo" [disabled]="true"
                                [ngClass]="{'input-error': !existeriesgo, 'input-normal': existeriesgo}">

                            <label class="oc-label">Tipo Compras</label>
                            <select class="oc-select" aria-label=".form-select-sm example" [(ngModel)]="BrokoptimalWallet.tiporiesgo"
                                [disabled]="true">
                                <option value="{{type}}" *ngFor="let type of purchaseTypes">{{type}}
                                </option>
                            </select>

                            <label class="oc-label">Valor Riesgo</label>
                            <input class="oc-input" type="number" [(ngModel)]="BrokoptimalWallet.riesgo" [disabled]="true">

                            <label class="oc-label">Comisión 2/2</label>
                            <input class="oc-input" type="number" [(ngModel)]="BrokoptimalWallet.comisionbroker" [disabled]="true">

                            <label class="oc-label">Stop Loss</label>
                            <input class="oc-input" type="number" [(ngModel)]="BrokoptimalWallet.stopLoss" [disabled]="true"
                                min="0.001" max="100">

                            <div class="oc-check-label">
                                <mat-slide-toggle [checked]="BrokoptimalWallet.chkgastogest" [(ngModel)]="BrokoptimalWallet.chkgastogest"
                                    [color]="'primary'" [disabled]="true">Gastos Gestión</mat-slide-toggle>
                            </div>
                            <input class="oc-input" type="number" [(ngModel)]="BrokoptimalWallet.gastosGestionPor" [disabled]="true">

                            <div class="oc-check-label">
                                <mat-slide-toggle [checked]="BrokoptimalWallet.chkgastoprest" [(ngModel)]="BrokoptimalWallet.chkgastoprest"
                                    [color]="'primary'" [disabled]="true">Gastos Prestamo %</mat-slide-toggle>
                            </div>
                            <input class="oc-input" type="number" [(ngModel)]="BrokoptimalWallet.gastosPrestamoPor" [disabled]="true">

                            <div class="oc-check-full">
                                <mat-slide-toggle [checked]="BrokoptimalWallet.participacion" [color]="'primary'" [disabled]="true">
                                    Comprar/Vender Fracciones</mat-slide-toggle>
                            </div>
                        </div>

                        <p class="text-danger small mt-1 mb-1">
                            Recordar : Cartera Broker vs Carteras Suscritas deben tener misma configuración
                        </p>

                        <div class="oc-actions">
                            <button mat-flat-button class="ccorbit oc-btn oc-btn--primary" (click)="openDialog()">
                                <mat-icon>settings</mat-icon> Reconfigurar
                            </button>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <div class="mb-4 col-md-3 p-0 m-0 resizable-column h-100" *ngIf="listaMercado" #column2 data-key="broker_col_lista">
            <div class="resizer" (mousedown)="startResizing($event, column2)" title="Arrastrar para redimensionar"></div>
            <mat-card class="enrolled-created-box ccorbit-card no-scrollbar h-100">
                <mat-card-content class="h-100 d-flex flex-column">
                    <h5 class="etiquetas">SELECCIONAR MERCADO</h5>
                    <div class="flex-fill overflow-auto">
                      <app-tablamercado [isBroker]="true" [stkcfd]="stkcfd"
                        [idcartera]="BrokoptimalWallet.idcartera"
                        [metaapi]="BrokoptimalWallet.tipoBroker === 'METAAPI'"></app-tablamercado>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <div class="col p-0 m-0 h-100 main-content-column">

            <ng-template #brokerActions>
                <button *ngIf="BrokoptimalWallet?.tipoBroker !== 'METAAPI'"
                    class="botones botones--icon botones--ghost" (click)="openBrokOp()"
                    matTooltip="Operaciones del broker" aria-label="Operaciones del broker"><mat-icon>list_alt</mat-icon></button>
                <button class="botones botones--icon botones--ghost" (click)="reset()"
                    matTooltip="Limpiar" aria-label="Limpiar"><mat-icon>cleaning_services</mat-icon></button>
                <button class="botones botones--icon botones--ghost" (click)="refrescar()"
                    matTooltip="Refrescar cartera y sincronizar histórico (MetaAPI)" aria-label="Refrescar"><mat-icon>refresh</mat-icon></button>

                <ng-container *ngIf="suscrito">
                    <span class="toolbar-divider"></span>
                    <button class="botones botones--warning" (click)="valoresTiempoReal(true)" [disabled]="actualizandoTiempoReal || automatizado"
                        [matTooltip]="automatizado ? 'Desactive la automatización para forzar entradas' : 'Forzar entradas con valores en tiempo real'">
                        <mat-icon *ngIf="!actualizandoTiempoRealManual">bolt</mat-icon>
                        <mat-spinner *ngIf="actualizandoTiempoRealManual" diameter="16"></mat-spinner>
                        Forzar Entradas
                    </button>
                    <button class="botones botones--warning" (click)="abrirSalirFinDia()" [disabled]="actualizandoTiempoReal || automatizado"
                        [matTooltip]="automatizado ? 'Desactive la automatización para salir a fin de día' : 'Forzar la salida de las operaciones entradas (cierra en el broker y cancela las OCO)'">
                        <mat-icon>logout</mat-icon> Salir Fin de Día
                    </button>
                    <button class="botones botones--primary" (click)="abrirSincronizarComparativa()"
                        matTooltip="Sincronizar operaciones del modelo con el broker">
                        <mat-icon>sync</mat-icon> Sincronizar
                    </button>
                    <button class="botones botones--icon botones--help" (click)="showAutomatizarHelp()"
                        matTooltip="Ayuda - Automatización" aria-label="Ayuda - Automatización"><mat-icon>help_outline</mat-icon></button>
                </ng-container>
            </ng-template>

            <div class="broker-toolbar" *ngIf="selectedTab !== 5">

                <div class="broker-toolbar__group">
                    <span class="cartera-title-tag">
                        <span class="cartera-title-tag__dot"></span>
                        CONTROL OPERATIVA: {{BrokoptimalWallet.nombre}}
                    </span>
                    <span class="cartera-title-tag" *ngIf="brokerClockText"
                          [matTooltip]="BrokoptimalWallet.tipoBroker === 'METAAPI' ? 'Hora del servidor del broker' : 'Hora del exchange (' + brokerClockZone + ')'"> HORA EXCHANGE{{ brokerClockLabel ? ' ' + brokerClockLabel : '' }}:
                        <mat-icon style="font-size:14px; width:14px; height:14px; vertical-align:middle;">schedule</mat-icon>
                        {{ brokerClockText }}
                    </span>
                </div>


                <div class="broker-toolbar__group">
                    <ng-container *ngTemplateOutlet="brokerActions"></ng-container>
                </div>
            </div>

            <mat-card class="enrolled-created-box no-scrollbar ccorbit-card h-100"
                [class.ccorbit-card--compact]="selectedTab === 5">
                <div class="alert alert-danger" *ngIf="mensageentradas.length > 0" role="alert">{{mensageentradas}}</div>

                <mat-card-content class="h-100 d-flex flex-column">
                    <div class="tab-group-wrapper h-100 d-flex flex-column">
                    <!--div class="tab-header-actions" *ngIf="suscrito && selectedTab !== 5">
                        <button class="botones" style="background-color: brown;" (click)="confirmar(true)"
                            *ngIf="!_cookieService.check('auto'+BrokoptimalWallet.idcartera)">Automatizar</button>
                        <button class="botones" style="background-color: rgb(58, 112, 17);" (click)="confirmar(true)"
                            *ngIf="_cookieService.check('auto'+BrokoptimalWallet.idcartera)">Automatizado</button>
                    </div-->
                    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms"
                        [selectedIndex]="selectedTab" (selectedTabChange)="onTabChange($event)" class="flex-fill">
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Contabilidad
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('gestion', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-planificador-gestion [selectedTab]="selectedTab" [isGestion]="isGestion"
                                [loading]="loading" [isBroker]="isBroker">
                            </app-planificador-gestion>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Operaciones
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('operaciones', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-operations [selectedTab]="selectedTab" [isGestion]="isGestion" [loading]="loading"
                                [isBroker]="isBroker"></app-operations>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Valores liquidativos
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('valores', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-liquidating-values [selectedTab]="selectedTab" [isGestion]="isGestion"
                                [loading]="loading" [isBroker]="isBroker"></app-liquidating-values>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Rendimientos/Riesgos
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('rendimientos', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-rendimientoriesgo [selectedTab]="selectedTab" [isGestion]="isGestion"
                                [loading]="loading" [isBroker]="isBroker"></app-rendimientoriesgo>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                Posiciones Cartera
                                <mat-icon class="tab-help-icon" (click)="showTabHelp('cartera', $event)" matTooltip="Ayuda">help_outline</mat-icon>
                            </ng-template>
                            <app-cartera [selectedTab]="selectedTab" [isGestion]="isGestion" [loading]="loading"
                                [isBroker]="isBroker" [stkcfd]="stkcfd"
                                (listaOrdenesBroker)="handleListaOrdenesBroker($event)">
                            </app-cartera>
                        </mat-tab>

                        <mat-tab [disabled]="!suscrito">
                            <ng-template mat-tab-label>
                                <span [style.color]="_cookieService.check('auto'+BrokoptimalWallet.idcartera) ? 'rgb(58,112,17)' : 'red'"
                                    style="pointer-events: auto;"
                                    [matTooltip]="'Cartera no tiene suscrito un modelo'"
                                    [matTooltipDisabled]="suscrito">
                                    {{_cookieService.check('auto'+BrokoptimalWallet.idcartera) ? 'Control Operativa' : 'Control Operativa'}}
                                </span>
                            </ng-template>
                            <div class="alert alert-warning" *ngIf="selectedTab === 5 && !suscrito" role="alert">
                                Cartera no tiene suscrito un modelo
                            </div>
                            <app-suscripciones-confirmar
                                *ngIf="selectedTab === 5 && BrokoptimalWallet?.idcartera && suscrito"
                                [idcarteraInput]="BrokoptimalWallet.idcartera"
                                [moduloInput]="'broker'"
                                [carteraInput]="BrokoptimalWallet.nombre"
                                [desdeInput]="desdeDate"
                                [idcarterasuscritaInput]="idcarterasuscrita"
                                [tipoBrokerInput]="BrokoptimalWallet.tipoBroker ?? 'IBKR'"
                                [metaApiAccountIdInput]="BrokoptimalWallet.metaApiAccountId ?? ''"
                                [brokerClockTextInput]="brokerClockText"
                                [brokerClockLabelInput]="brokerClockLabel"
                                [walletMetricsInput]="walletMetrics"
                                (ocoChange)="isOco = $event">
                                <div toolbarActions class="control-op-actions broker-toolbar__group">
                                    <button mat-icon-button (click)="togglePanelControl('pos')"
                                        [class.toolbar-btn--active]="mostrarPosicionesControl"
                                        matTooltip="Ver posiciones de la cartera" aria-label="Ver posiciones">
                                        <mat-icon style="font-size:18px;width:18px;height:18px;line-height:18px;">account_balance_wallet</mat-icon>
                                    </button>
                                    <button mat-icon-button (click)="togglePanelControl('ord')"
                                        [class.toolbar-btn--active]="mostrarOrdenesControl"
                                        matTooltip="Ver lista de órdenes" aria-label="Ver órdenes">
                                        <mat-icon style="font-size:18px;width:18px;height:18px;line-height:18px;">receipt_long</mat-icon>
                                    </button>
                                    <button mat-icon-button (click)="togglePanelControl('mt')"
                                        [class.toolbar-btn--active]="mostrarOperacionesMtControl"
                                        matTooltip="Operaciones (vista MetaTrader)" aria-label="Ver operaciones vista MetaTrader">
                                        <mat-icon style="font-size:18px;width:18px;height:18px;line-height:18px;">table_rows</mat-icon>
                                    </button>
                                    <ng-container *ngTemplateOutlet="brokerActions"></ng-container>
                                </div>
                                <div panelesBroker class="control-paneles">
                                    <!-- La salida desde posiciones ya refresca las órdenes vía updatecargarListas -->
                                    <ng-container *ngIf="mostrarPosicionesControl">
                                        <app-posiciones-broker #posCtrl [stkcfd]="stkcfd" [alto]="altoPosicionesControl + 'px'"
                                            [controlOperativa]="true" [ordenes]="listaOrdenesBroker"></app-posiciones-broker>
                                        <div class="split-handle" matTooltip="Arrastrar para cambiar el alto (doble clic: restaurar)"
                                            (mousedown)="iniciarResizeControl($event, 'posiciones', posCtrl)"
                                            (dblclick)="resetAltoControl('posiciones', posCtrl)"></div>
                                    </ng-container>
                                    <ng-container *ngIf="mostrarOrdenesControl">
                                        <app-lista-ordenes #ordCtrl [alto]="altoOrdenesControl + 'px'" [mostrarCola]="true"
                                            [consultarEstadoBroker]="false" [controlOperativa]="true"></app-lista-ordenes>
                                        <div class="split-handle" matTooltip="Arrastrar para cambiar el alto (doble clic: restaurar)"
                                            (mousedown)="iniciarResizeControl($event, 'ordenes', ordCtrl)"
                                            (dblclick)="resetAltoControl('ordenes', ordCtrl)"></div>
                                    </ng-container>
                                    <ng-container *ngIf="mostrarOperacionesMtControl">
                                        <app-operaciones-mt #mtCtrl [alto]="altoOperacionesMtControl + 'px'" [mostrarCola]="true"
                                            [controlOperativa]="true"></app-operaciones-mt>
                                        <div class="split-handle" matTooltip="Arrastrar para cambiar el alto (doble clic: restaurar)"
                                            (mousedown)="iniciarResizeControl($event, 'operacionesMt', mtCtrl)"
                                            (dblclick)="resetAltoControl('operacionesMt', mtCtrl)"></div>
                                    </ng-container>
                                </div>
                            </app-suscripciones-confirmar>
                        </mat-tab>


                    </mat-tab-group>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

    </div>
</div>